/* kn-popup : email capture popup (20/10). No dependencies.
   Shows after the delay or the scroll depth, whichever comes first.
   Never on cart, checkout or account pages. In the theme editor, only while the section is selected.
   Close is remembered for N days, a signup is remembered for good. */
(function () {
  'use strict';

  var KEY_CLOSED = 'kn-popup-closed';
  var KEY_DONE = 'kn-popup-subscribed';
  var KEY_PENDING = 'kn-popup-pending';
  var KEY_BUYER = 'kn-popup-buyer';
  function cartHasItems() {
    var b = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    return !!(b && parseInt(b.textContent, 10) > 0);
  }
  var FORM_HASH = '#kn-popup-form';
  var PENDING_MS = 15 * 60 * 1000;
  var DAY_MS = 24 * 60 * 60 * 1000;
  var BLOCKED_PATH = /^\/(?:[a-z]{2}(?:-[a-z]{2,4})?\/)?(?:cart|checkout|checkouts|account|challenge)(?:\/|$)/i;
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  /* ---------- storage, always wrapped: private mode or blocked storage must never break the page ---------- */
  function storage(name) {
    try {
      var s = window[name];
      s.setItem('__knp', '1');
      s.removeItem('__knp');
      return s;
    } catch (e) {
      return null;
    }
  }
  var local = storage('localStorage');
  var session = storage('sessionStorage');
  function read(s, k) {
    try { return s ? s.getItem(k) : null; } catch (e) { return null; }
  }
  function write(s, k, v) {
    try { if (s) s.setItem(k, v); } catch (e) { /* ignore */ }
  }
  function drop(s, k) {
    try { if (s) s.removeItem(k); } catch (e) { /* ignore */ }
  }

  function reducedMotion() {
    try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; }
  }
  function isVisible(el) {
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }
  /* another layer already open: header search, cart drawer, menu drawer or any Dawn modal */
  function otherLayerOpen() {
    if (document.querySelector('details-modal.header__search details[open]')) return true;
    if (document.querySelector('cart-drawer.active')) return true;
    if (document.querySelector('header-drawer details[open]')) return true;
    return /(^|\s)overflow-hidden/.test(document.body.className);
  }

  var current = null;

  function Popup(root) {
    var self = this;
    this.root = root;
    this.sectionId = root.getAttribute('data-section-id');
    this.designMode = root.getAttribute('data-design-mode') === 'true' || !!(window.Shopify && window.Shopify.designMode);
    this.delay = Math.max(0, parseFloat(root.getAttribute('data-delay')) || 8) * 1000;
    this.scrollPct = parseFloat(root.getAttribute('data-scroll')) || 40;
    this.exitIntent = root.getAttribute('data-exit') === '1';
    this.days = parseFloat(root.getAttribute('data-days')) || 7;
    this.card = root.querySelector('.knp__card');
    this.form = root.querySelector('form');
    this.input = root.querySelector('.knp__input');
    this.error = root.querySelector('.knp__error');
    this.submit = root.querySelector('[data-knp-submit]');
    this.success = root.querySelector('.knp__view--success');
    this.state = this.success ? this.success.getAttribute('data-state') : 'idle';
    this.img = root.querySelector('.knp__img');
    this.isOpen = false;
    this.lastFocus = null;
    this.timer = null;
    this.retry = null;
    this.hideTimer = null;

    this.onKey = function (e) { self.handleKey(e); };
    this.onFocusIn = function (e) {
      if (self.isOpen && !self.root.contains(e.target)) self.card.focus({ preventScroll: true });
    };
    this.onScroll = function () { self.checkScroll(); };
    this.onPageShow = function () {
      if (self.submit) self.submit.removeAttribute('aria-busy');
    };

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-knp-close]')) {
        e.preventDefault();
        self.close(true);
      }
      var copy = e.target.closest('[data-knp-copy]');
      if (copy) self.copy(copy);
    });
    if (this.form) {
      this.form.addEventListener('submit', function (e) { self.handleSubmit(e); });
    }
    if (this.input) {
      this.input.addEventListener('input', function () {
        if (self.input.getAttribute('aria-invalid') === 'true') self.clearError();
      });
    }
    window.addEventListener('pageshow', this.onPageShow);

    this.start();
  }

  Popup.prototype.start = function () {
    var self = this;
    /* in the editor: only shown on section select (see the listeners at the bottom) */
    if (this.designMode) return;

    /* back from a popup signup: Shopify returns with ?customer_posted=true#kn-popup-form */
    var pendingAt = parseInt(read(session, KEY_PENDING), 10);
    var fromPopup = window.location.hash === FORM_HASH || (pendingAt && Date.now() - pendingAt < PENDING_MS);
    if (fromPopup && (this.state === 'success' || this.state === 'error')) {
      drop(session, KEY_PENDING);
      if (this.state === 'success') write(local, KEY_DONE, '1');
      this.cleanUrl();
      this.open();
      return;
    }
    /* a signup or an error from another customer form on the page (newsletter section): not ours to show */
    if (this.state === 'success') {
      write(local, KEY_DONE, '1');
      return;
    }
    if (this.state === 'error') {
      this.clearError();
      if (this.input) this.input.value = '';
      this.state = 'idle';
    }

    if (BLOCKED_PATH.test(window.location.pathname)) return;
    /* a buyer is never interrupted: cart not empty, or Add to cart clicked in this visit */
    if (read(session, KEY_BUYER) || cartHasItems()) return;
    document.addEventListener('submit', function (e) {
      if (e.target && /\/cart\/add/.test(e.target.getAttribute('action') || '')) self.cancelForBuyer();
    }, true);
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('[name="add"], [data-kn-cta]')) self.cancelForBuyer();
    }, true);
    if (read(local, KEY_DONE)) return;
    var closedAt = parseInt(read(local, KEY_CLOSED), 10);
    if (closedAt && Date.now() - closedAt < this.days * DAY_MS) return;

    this.timer = window.setTimeout(function () { self.trigger(); }, this.delay);
    if (this.exitIntent && window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      var armedAt = Date.now();
      this.onExit = function (e) {
        if (e.relatedTarget || e.clientY > 0) return;
        if (Date.now() - armedAt < 3000) return;
        document.removeEventListener('mouseout', self.onExit);
        self.trigger();
      };
      document.addEventListener('mouseout', this.onExit);
    }
    window.addEventListener('scroll', this.onScroll, { passive: true });
    /* warm the image a little before it is needed */
    var warm = function () {
      if (self.img && self.img.loading === 'lazy') self.img.loading = 'eager';
    };
    if (document.readyState === 'complete') window.setTimeout(warm, 1500);
    else window.addEventListener('load', function () { window.setTimeout(warm, 1500); });
  };

  Popup.prototype.cancelForBuyer = function () {
    write(session, KEY_BUYER, '1');
    window.clearTimeout(this.timer);
    window.clearTimeout(this.retry);
    window.removeEventListener('scroll', this.onScroll);
    if (this.onExit) document.removeEventListener('mouseout', this.onExit);
  };

  Popup.prototype.checkScroll = function () {
    var doc = document.documentElement;
    var max = Math.max(doc.scrollHeight, document.body.scrollHeight) - window.innerHeight;
    if (max <= 0) return;
    var y = window.pageYOffset || doc.scrollTop;
    if ((y / max) * 100 >= this.scrollPct) this.trigger();
  };

  Popup.prototype.trigger = function () {
    var self = this;
    window.clearTimeout(this.timer);
    window.removeEventListener('scroll', this.onScroll);
    if (this.isOpen) return;
    if (!this.designMode && (read(session, KEY_BUYER) || cartHasItems())) return;
    if (otherLayerOpen()) {
      window.clearTimeout(this.retry);
      this.retry = window.setTimeout(function () { self.trigger(); }, 1500);
      return;
    }
    this.open();
  };

  Popup.prototype.open = function () {
    if (this.isOpen || !this.card) return;
    var root = this.root;
    window.clearTimeout(this.hideTimer);
    this.isOpen = true;
    this.lastFocus = document.activeElement;
    if (this.img && this.img.loading === 'lazy') this.img.loading = 'eager';

    var showSuccess = this.success && !this.success.hasAttribute('hidden');
    this.card.setAttribute('aria-labelledby', showSuccess ? 'knp-title-success' : 'knp-title');

    var gap = window.innerWidth - document.documentElement.clientWidth;
    if (gap > 0) document.body.style.paddingRight = gap + 'px';
    document.documentElement.classList.add('knp-lock');

    root.hidden = false;
    void root.offsetWidth;
    root.classList.add('is-open');

    document.addEventListener('keydown', this.onKey);
    document.addEventListener('focusin', this.onFocusIn);

    var target = this.card;
    if (showSuccess) target = root.querySelector('#knp-title-success') || this.card;
    else if (this.state === 'error' && this.input) target = this.input;
    target.focus({ preventScroll: true });
  };

  Popup.prototype.close = function (remember) {
    if (!this.isOpen) return;
    var self = this;
    this.isOpen = false;
    this.root.classList.remove('is-open');
    document.removeEventListener('keydown', this.onKey);
    document.removeEventListener('focusin', this.onFocusIn);
    document.documentElement.classList.remove('knp-lock');
    document.body.style.paddingRight = '';

    if (remember && !this.designMode) write(local, KEY_CLOSED, String(Date.now()));

    var hide = function () {
      if (!self.isOpen) self.root.hidden = true;
    };
    if (reducedMotion() || this.designMode) hide();
    else this.hideTimer = window.setTimeout(hide, 320);

    var back = this.lastFocus;
    this.lastFocus = null;
    if (back && back.focus && document.contains(back) && back !== document.body) {
      try { back.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
    }
  };

  Popup.prototype.handleKey = function (e) {
    if (!this.isOpen) return;
    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      this.close(true);
      return;
    }
    if (e.key !== 'Tab') return;
    var items = Array.prototype.filter.call(this.card.querySelectorAll(FOCUSABLE), isVisible);
    if (!items.length) {
      e.preventDefault();
      return;
    }
    var first = items[0];
    var last = items[items.length - 1];
    var active = document.activeElement;
    if (e.shiftKey && (active === first || active === this.card || !this.card.contains(active))) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && (active === last || !this.card.contains(active))) {
      e.preventDefault();
      first.focus();
    }
  };

  Popup.prototype.showError = function (msg) {
    if (!this.error || !this.input) return;
    this.error.textContent = msg;
    this.error.hidden = false;
    this.input.setAttribute('aria-invalid', 'true');
  };

  Popup.prototype.clearError = function () {
    if (!this.error || !this.input) return;
    this.error.hidden = true;
    this.error.textContent = '';
    this.input.removeAttribute('aria-invalid');
  };

  Popup.prototype.handleSubmit = function (e) {
    if (!this.input) return;
    if (this.submit && this.submit.getAttribute('aria-busy') === 'true') {
      e.preventDefault();
      return;
    }
    var value = this.input.value.trim();
    this.input.value = value;
    if (!value) {
      e.preventDefault();
      this.showError('Please enter your email address.');
      this.input.focus();
      return;
    }
    if (!this.input.checkValidity() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      e.preventDefault();
      this.showError('Please enter a valid email address.');
      this.input.focus();
      return;
    }
    if (this.designMode) {
      e.preventDefault();
      return;
    }
    this.clearError();
    write(session, KEY_PENDING, String(Date.now()));
    if (this.submit) this.submit.setAttribute('aria-busy', 'true');
  };

  Popup.prototype.copy = function (btn) {
    var codeEl = this.root.querySelector('[data-knp-code]');
    var live = this.root.querySelector('[data-knp-live]');
    if (!codeEl) return;
    var code = codeEl.textContent.trim();
    var label = btn.getAttribute('data-label') || 'Copy code';
    var done = btn.getAttribute('data-done') || 'Copied';
    var card = this.card;

    var ok = function () {
      btn.textContent = done;
      if (live) live.textContent = 'Code ' + code + ' copied';
      window.setTimeout(function () {
        btn.textContent = label;
        if (live) live.textContent = '';
      }, 2000);
    };
    var selectCode = function () {
      try {
        var range = document.createRange();
        range.selectNodeContents(codeEl);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
      } catch (e) { /* ignore */ }
    };
    var legacy = function () {
      var ta = document.createElement('textarea');
      ta.value = code;
      ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;';
      card.appendChild(ta);
      ta.select();
      var copied = false;
      try { copied = document.execCommand('copy'); } catch (e) { copied = false; }
      card.removeChild(ta);
      btn.focus({ preventScroll: true });
      return copied;
    };

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(code).then(ok, function () {
        if (legacy()) ok(); else selectCode();
      });
    } else if (legacy()) {
      ok();
    } else {
      selectCode();
    }
  };

  /* drop ?customer_posted=true and #kn-popup-form so a refresh does not reopen the popup */
  Popup.prototype.cleanUrl = function () {
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete('customer_posted');
      url.hash = '';
      window.history.replaceState(window.history.state, '', url.pathname + url.search);
    } catch (e) { /* ignore */ }
  };

  Popup.prototype.destroy = function () {
    window.clearTimeout(this.timer);
    window.clearTimeout(this.retry);
    window.clearTimeout(this.hideTimer);
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('pageshow', this.onPageShow);
    document.removeEventListener('keydown', this.onKey);
    document.removeEventListener('focusin', this.onFocusIn);
    if (this.isOpen) {
      document.documentElement.classList.remove('knp-lock');
      document.body.style.paddingRight = '';
    }
    this.isOpen = false;
  };

  function init() {
    var root = document.getElementById('kn-popup');
    if (current && current.root === root) return;
    if (current) current.destroy();
    current = root ? new Popup(root) : null;
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* theme editor: open while the section is selected, close on deselect, re-init after a settings change */
  function isMine(e) {
    var root = document.getElementById('kn-popup');
    var id = e.detail && e.detail.sectionId;
    if (root && id && root.getAttribute('data-section-id') === id) return true;
    return !!(e.target && e.target.querySelector && e.target.querySelector('#kn-popup'));
  }
  document.addEventListener('shopify:section:select', function (e) {
    if (!isMine(e)) return;
    init();
    if (current) current.open();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (isMine(e) && current) current.close(false);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (current && e.target && e.target.contains && e.target.contains(current.root)) {
      current.destroy();
      current = null;
    }
  });
  document.addEventListener('shopify:section:load', function (e) {
    if (!isMine(e)) return;
    init();
    if (current && current.designMode) current.open();
  });
})();
